import { IconProps } from "../../../types/style";

const BuildingSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6 4.65002V6.5H9.12C7.50999 6.5 6.70001 7.30998 6.70001 8.91998V18.5H4.15002C2.72002 18.5 2 17.78 2 16.35V4.65002C2 3.22002 2.72002 2.5 4.15002 2.5H8.45001C9.88001 2.5 10.6 3.22002 10.6 4.65002Z"
          fill={color}
        />
        <path
          opacity="0.4"
          d="M17.3699 8.91998V20.08C17.3699 21.69 16.57 22.5 14.96 22.5H9.11993C7.50993 22.5 6.69995 21.69 6.69995 20.08V8.91998C6.69995 7.30998 7.50993 6.5 9.11993 6.5H14.96C16.57 6.5 17.3699 7.30998 17.3699 8.91998Z"
          fill={color}
        />
        <path
          d="M22 4.65002V16.35C22 17.78 21.28 18.5 19.85 18.5H17.37V8.91998C17.37 7.30998 16.57 6.5 14.96 6.5H13.4V4.65002C13.4 3.22002 14.12 2.5 15.55 2.5H19.85C21.28 2.5 22 3.22002 22 4.65002Z"
          fill={color}
        />
        <path
          d="M14 12.25H10C9.59 12.25 9.25 11.91 9.25 11.5C9.25 11.09 9.59 10.75 10 10.75H14C14.41 10.75 14.75 11.09 14.75 11.5C14.75 11.91 14.41 12.25 14 12.25Z"
          fill={color}
        />
        <path
          d="M14 15.25H10C9.59 15.25 9.25 14.91 9.25 14.5C9.25 14.09 9.59 13.75 10 13.75H14C14.41 13.75 14.75 14.09 14.75 14.5C14.75 14.91 14.41 15.25 14 15.25Z"
          fill={color}
        />
        <path
          d="M12.75 19.5V22.5H11.25V19.5C11.25 19.09 11.59 18.75 12 18.75C12.41 18.75 12.75 19.09 12.75 19.5Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default BuildingSVG;
